import THEMES from '../../constants/theme-properties';

/**
 * Sets the brand theme to CSS.
 * @param {String} brand the brand name e.g. NatWest, RBS
 */
export default function setTheme(brand) {
  const { bodyClassName, favicon } = THEMES[brand.toLowerCase()];
  const { body } = document;
  const faviconLink = document.getElementById('favicon');

  // set brand favicon
  faviconLink.href = favicon;

  // set theme class name to document body
  body.className = bodyClassName;
}
